export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

declare global {
	interface Window {
		dataLayer: any
	}
}

export const gtmEvent = ({ event, data }: any) => {
	if (typeof window !== 'undefined' && !!window?.dataLayer)
		window.dataLayer.push({ event, ...data })
}
